const generatePathParts = (pathStr) => {
  const pathWithoutQuery = pathStr.split("?")[0];
  return pathWithoutQuery.split("/").filter((v) => v.length > 0);
};

export default function generateBreadcrumbs({ router }) {
  const pathnameNestedRoutes = generatePathParts(router);
  const crumblist = pathnameNestedRoutes?.map((item, idx) => {
    const uri = "/" + pathnameNestedRoutes.slice(0, idx + 1).join("/");
    return {
      uri,
      title: item?.replaceAll("-", " "),
    };
  });

  return crumblist?.[0]?.title == "member area"
    ? [...crumblist]
    : [{ uri: "/", title: "Home" }, ...crumblist];
}
